import { render, staticRenderFns } from "./OrganizationSelect.vue?vue&type=template&id=5c6b3e4c&"
import script from "./OrganizationSelect.vue?vue&type=script&lang=js&"
export * from "./OrganizationSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports